<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <!-- Button Imprimir -->
            <v-col cols="6" md="6">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("btnPrint") }}
              </v-btn>
            </v-col>
            <!-- End Button Imprimir -->
            <v-col
              cols="6"
              sm="6"
              class="d-flex flex-row-reverse d-md-none d-sm-none"
            >
              <div>
                <v-btn-toggle dense>
                  <v-btn @click="breakpoint = 0">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>

                  <v-btn @click="breakpoint = 'xs'">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <!-- Search Table -->
            <v-col cols="12" lg="4" md="6" sm="6">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('labelSearch')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
            <!-- End Search Table -->
          </v-row>
        </div>
        <v-divider></v-divider>

        <div>
          <!-- ======================= -->
          <!-- FORMAT LIST (DATATABLE) -->
          <!-- ======================= -->
          <v-data-table
            :headers="headers"
            :items="dataTable"
            :items-per-page="-1"
            :footer-props="{
              'items-per-page-text': $t('rowsPerPage'),
            }"
            :search="search"
            :mobile-breakpoint="breakpoint"
            class="mb-4"
          >
            <template slot="no-data">
              <div></div>
            </template>
            <template v-slot:item.local_id="{ item }">
              <v-btn @click="$copy(item.local_id)" x-small>{{
                item.local_id
              }}</v-btn>
            </template>
            <template v-slot:item.affiliate_id="{ item }">
              <v-btn @click="$copy(item.affiliate_id)" x-small>{{
                item.affiliate_id
              }}</v-btn>
            </template>

            <template v-slot:item.local_name="{ item }">
              <a
                class="green--text caption"
                @click="
                  $profile.showProfileDrawer(
                    item.local_id,
                    '/regionalManager/locals/getLocal'
                  )
                "
              >
                <v-icon color="orange" x-small>mdi-account-tie</v-icon>
                {{ item.local_name }}
              </a>
            </template>

            <template v-slot:item.affiliate_name="{ item }">
              <a
                class="blue--text caption"
                @click="
                  $profile.showProfileDrawer(
                    item.affiliate_id,
                    'regionalManager/agents/getAgent'
                  )
                "
              >
                <v-icon color="primary" x-small>mdi-account</v-icon>
                {{ item.affiliate_name }}
              </a>
            </template>

            <!-- <template v-slot:item.affiliate_detail="{ item }">
              <div class="d-flex justify-start">
                <CasinoGameComissionsByAffiliate
                  :agent_name="item.affiliate_name"
                  :id_affiliate="item.affiliate_id"
                />
              </div>
            </template> -->

            <template v-slot:item.total_active_players="{ item }">
              <div class="caption ma-1">
                {{ item.total_active_players }} /
                {{ item.min_active_players_to_commission }}

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      v-bind="attrs"
                      v-on="on"
                      class="d-print-none"
                    >
                      <v-icon small color="info">
                        mdi-information-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    $tc(
                      "usersActivesByAffiliateRemainingTooltip",
                      item.total_active_players >=
                        item.min_active_players_to_commission
                        ? 0
                        : item.min_active_players_to_commission -
                            item.total_active_players,
                      {
                        remainingUsers:
                          item.min_active_players_to_commission -
                          item.total_active_players,
                      }
                    )
                  }}</span>
                </v-tooltip>
              </div>
            </template>

            <!-- VALUES -->
            <template
              v-for="(value, index) in valueColors"
              v-slot:[`item.${value}`]="{ item }"
            >
              <span
                class="caption"
                :key="index"
                :class="
                  getColor(
                    value == 'fee_ggr_percentage'
                      ? item[value] * -1
                      : item[value]
                  )
                "
              >
                {{ addZeroes(item[value]) }}
              </span>
            </template>

            <template v-slot:item.affiliate_commission="{ item }">
              <div
                v-if="item.hasMinActivePlayersToComission"
                class="caption ma-1"
                :class="getColor(item.affiliate_commission)"
              >
                {{ addZeroes(item.affiliate_commission) }}
              </div>
              <div v-else class="caption ma-1">
                <span>•••</span>
              </div>
            </template>

            <template v-slot:item.local_commission="{ item }">
              <div
                v-if="item.hasMinActivePlayersToComission"
                class="caption ma-1"
                :class="getColor(item.local_commission)"
              >
                {{ addZeroes(item.local_commission) }}
              </div>
              <div v-else class="caption ma-1">
                <span>•••</span>
              </div>
            </template>

            <template v-slot:item.regional_commission="{ item }">
              <div
                v-if="item.hasMinActivePlayersToComission"
                class="caption ma-1"
                :class="getColor(item.regional_commission)"
              >
                {{ addZeroes(item.regional_commission) }}
              </div>
              <div v-else class="caption ma-1">
                <span>•••</span>
              </div>
            </template>

            <template
              v-for="(key, index) in keysResume"
              v-slot:[`header.${key}`]="{ header }"
            >
              <span :key="key + index" class="caption">{{ header.text }}</span>
              <v-tooltip top :key="index">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                    class="d-print-none"
                  >
                    <v-icon small color="info">
                      mdi-information-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ infoKey(key) }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-card>

      <!-- Resume -->
      <div class="mt-4" v-if="keysResume.length > 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("periodSummary") }}
                <v-icon class="float-right mr-3" @click="$copy(resumePrint)">
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr
                      v-for="(item, index) in keysResume"
                      :key="`${index} ${Math.random()}`"
                    >
                      <td class="caption">
                        {{ TranslateKey(item) }}
                      </td>
                      <td class="text-right" :class="resume[item].classColor">
                        {{
                          item === "qtdAgents" ||
                          item === "total_active_players"
                            ? resume[item].value
                            : addZeroes(resume[item].value)
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";
// import CasinoGameComissionsByAffiliate from "./CasinoGameComissionsByAffiliate";
import hasFeeValue from "@/util/hasFeeValue";

export default {
  name:
    "views-backoffice-regional-manager-accountabilityOnline-regionalManagerAffiliates",
  components: {
    HeaderPrint,
    // CasinoGameComissionsByAffiliate,
  },
  data: () => ({
    search: "",
    breakpoint: "xs",
    dataTable: [],
    resume: null,
    keysResume: [],
    valueColors: [
      "affiliate_commission",
      "regional_commission",
      "gross_value",
      "local_commission",
      "prize_value",
      "value_ggr",
      "fee_ggr_percentage",
      "value_ngr",
    ],
  }),
  computed: {
    showAffiliateDetail() {
      return false;

      // if (this.$hasNewCasino()) {
      //   return false;
      // }

      // return (
      //   this.$store.state.operator.casino &&
      //   this.$store.state.operator.casino != "0"
      // );
    },
    rangeDate() {
      return this.$store.state.range.date;
    },

    saveFilters() {
      return this.$store.state.filters.save;
    },

    hasFeeValue() {
      return hasFeeValue;
    },

    headers() {
      const headers = [
        {
          text: this.$t("localManagerId"),
          value: "local_id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("localManagerName"),
          value: "local_name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("affiliateId"),
          value: "affiliate_id",
          align: "end",
          sortable: false,
        },
        {
          text: this.$t("affiliate"),
          value: "affiliate_name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("usersActivesByAffiliate"),
          value: "total_active_players",
          align: "start",
        },
        {
          text: this.$t("grossValue"),
          value: "gross_value",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("prizeValue"),
          value: "prize_value",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("valueGGR"),
          value: "value_ggr",
          align: "center",
          sortable: false,
        },
        ...(this.hasFeeValue
          ? [
              {
                text: this.$t("feeValue"),
                value: "fee_ggr_percentage",
                align: "center",
                sortable: false,
              },
            ]
          : []),
        ...(this.hasFeeValue
          ? [
              {
                text: "NGR",
                value: "value_ngr",
                align: "center",
                sortable: false,
              },
            ]
          : []),
        {
          text: this.$t("affiliateCommission"),
          value: "affiliate_commission",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("localManagerCommission"),
          value: "local_commission",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("regionalManagerCommission"),
          value: "regional_commission",
          align: "center",
          sortable: false,
        },
      ];

      if (this.showAffiliateDetail) {
        headers.push({
          text: this.$t("actions"),
          value: "affiliate_detail",
          align: "caption",
          sortable: false,
        });
      }

      return headers;
    },

    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
  },

  watch: {
    saveFilters(val) {
      val && this.getLocalComissions();
    },
  },
  methods: {
    reset() {
      this.dataTable = [];
      this.keysResume = [];
    },
    async getLocalComissions() {
      this.reset();
      const body = {
        ...this.rangeDate,
        export: this.exportDoc,
      };

      let response;

      if (this.exportDoc) {
        const extension = this.exportDoc;
        response = await this.$request.exportDoc(
          "regionalManager/financial/affiliatesExtract",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post(
          "regionalManager/financial/affiliatesExtract",
          body
        );
      }
      if (!response.dados) return;

      try {
        this.dataTable = response.dados;
        // Trata os valores de comissões convertendo em valores negativos
        this.dataTable.forEach((item) => {
          if (item.value_ggr < 0) {
            item.affiliate_commission = 0;
            item.local_commission = 0;
            item.regional_commission = 0;
          } else {
            item.affiliate_commission = item.affiliate_commission * -1;
            item.local_commission = item.local_commission * -1;
            // item.regional_commission = item.regional_commission * -1;
          }

          const fee_ggr_percentage_calc =
            item.value_ggr * (item.affiliate_fee / 100);

          item.fee_ggr_percentage = (fee_ggr_percentage_calc > 0
            ? fee_ggr_percentage_calc
            : 0
          ).toFixed(2);

          item.prize_value = item.prize_value * -1;

          item.total_active_players = parseFloat(item.total_active_players);
          item.min_active_players_to_commission = parseFloat(
            item.min_active_players_to_commission
          );

          if (
            item.total_active_players >= item.min_active_players_to_commission
          ) {
            item.hasMinActivePlayersToComission = true;
          }
        });

        this.buildResumeData(this.dataTable);
      } catch (error) {
        console.log(error);
      }

      // await this.$request
      //   .post("/regionalManager/financial/regionalOnlineComissions", body)
      //   .then((response) => {
      //     // Lógica para não entrar no forEach caso o request não encontre dados
      //     if (!response.dados) return;
      //     this.dataTable = response.dados;
      //     // Trata os valores de comissões convertendo em valores negativos
      //     this.dataTable.forEach((item) => {
      //       if (item.value_ggr < 0) {
      //         item.affiliate_commission = 0;
      //         item.local_commission = 0;
      //         item.regional_commission = 0;
      //       } else {
      //         item.affiliate_commission = item.affiliate_commission * -1;
      //         item.local_commission = item.local_commission * -1;
      //         // item.regional_commission = item.regional_commission * -1;
      //       }
      //       item.prize_value = item.prize_value * -1;
      //     });

      //     this.buildResumeData(this.dataTable);
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    },

    buildResumeData(dados) {
      if (!dados) return;
      const sum = (key) => {
        return dados
          .map((item) => Number(item[key]))
          .reduce((a, b) => a + b, 0)
          .toFixed(2);
      };
      let resume = {
        gross_value: {},
        prize_value: {},
        value_ggr: {},
        fee_ggr_percentage: {},
        value_ngr: {},
        affiliate_commission: {},
        local_commission: {},
        regional_commission: {},
      };
      Object.keys(resume).forEach((key) => {
        const total = sum(key);
        resume[key].value = `${total}`;
        resume[key].classColor = this.getColor(
          key === "fee_ggr_percentage" ? total * -1 : total
        );
      });
      const complement = {
        qtdAgents: { value: dados.length },
        total_active_players: { value: Number(sum("total_active_players")) },
        gross_value: { value: Number(sum("gross_value")) },
        prize_value: { value: Number(sum("prize_value")) },
        value_ggr: { value: Number(sum("value_ggr")) },
        fee_ggr_percentage: {},
        value_ngr: { value: Number(sum("value_ngr")) },
        affiliate_commission: { value: Number(sum("affiliate_commission")) },
        local_commission: { value: Number(sum("local_commission")) },
      };
      this.resume = {
        ...complement,
        ...resume,
      };
      this.keysResume = Object.keys(this.resume);
      this.resumeExcelCopy();
      // console.log("resume", this.resume);
    },
    resumeExcelCopy() {
      // Create String with table to Copy on Btn

      // Os espaços e indentações da String concatResume é necessária para não
      // quebrar ao copiar
      let concatResume = `
        <table>
          <tr>${this.resume.qtdAgents.value.toString().replace(".", ",")}</tr>
          <tr>${this.resume.total_active_players.value
            .toString()
            .replace(".", ",")}</tr>
          <tr>${this.resume.gross_value.value.toString().replace(".", ",")}</tr>
          <tr>${this.resume.prize_value.value.toString().replace(".", ",")}</tr>
          <tr>${this.resume.value_ggr.value.toString().replace(".", ",")}</tr>`;
      if (this.hasFeeValue) {
        concatResume += `
          <tr>${this.resume.fee_ggr_percentage.value
            .toString()
            .replace(".", ",")}</tr>
          <tr>${this.resume.value_ngr.value.toString().replace(".", ",")}</tr>`;
      }
      concatResume += `
          <tr>${this.resume.affiliate_commission.value
            .toString()
            .replace(".", ",")}</tr>
          <tr>${this.resume.local_commission.value
            .toString()
            .replace(".", ",")}</tr>
          <tr>${this.resume.regional_commission.value
            .toString()
            .replace(".", ",")}</tr>
        `;
      concatResume += "</table>";
      this.resumePrint = concatResume;
    },
    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
    TranslateKey: function(key) {
      const myKeysTranslated = {
        qtdAgents: this.$t("qtyAffiliates"),
        total_active_players: this.$t("qtyUsersActives"),
        gross_value: this.$t("grossValue"),
        prize_value: this.$t("prizeValue"),
        value_ggr: this.$t("valueGGR"),
        fee_ggr_percentage: this.$t("feeValue"),
        value_ngr: "NGR",
        affiliate_commission: this.$t("affiliateCommission"),
        local_commission: this.$t("localManagerCommission"),
        regional_commission: this.$t("regionalManagerCommission"),
      };
      return myKeysTranslated[key] || null;
    },
    infoKey: function(key) {
      const info = {
        affiliate_name: this.$t("infoAgentName"),
        qtdAgents: this.$t("qtyAffiliates"),
        total_active_players: this.$t("usersActivesByAffiliateExplanation"),
        gross_value: this.$t("infoGrossValue"),
        prize_value: this.$t("infoPrizeValue"),
        value_ggr: this.$t("infoValueGGR"),
        fee_ggr_percentage: this.$t("feeGGRPercentageExplanation"),
        value_ngr: this.$t("valueNGRExplanation"),
        affiliate_commission: this.$t("affiliateCommissionExplanation"),
        local_commission: this.$t("infoLocalCommission"),
        regional_commission: this.$t("infoRegionalCommission"),
      };
      return info[key] || null;
    },

    addZeroes(num) {
      if (typeof num !== "string") {
        num = num.toString();
      }

      const dec = num.split(".")[1];
      const len = dec && dec.length > 2 ? dec.length : 2;
      return Number(num).toFixed(len);
    },
  },
};
</script>
